import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import { Employee } from "../../../api";
import { useAuth } from "../../../hooks";

const employeeController = new Employee();

/**
 * value                      - numero_legajo seleccionado
 * onChange(legajo)           - llamado con el numero_legajo
 * onEmployeeChange(employee) - llamado con el objeto completo del empleado
 */
export function SelectRecord({ value, onChange, onEmployeeChange, placeholder = "Seleccionar legajo", fluid = true }) {
  const { accessToken } = useAuth();
  const [employees, setEmployees] = useState([]);
  const [options,   setOptions]   = useState([]);
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await employeeController.getEmployees(accessToken, { active: true });
        const conLegajo = data.filter((e) => e.numero_legajo);
        setEmployees(conLegajo);
        setOptions(
          conLegajo.map((e) => ({
            key:   e._id,
            value: e.numero_legajo,
            text:  `${e.numero_legajo} — ${e.nombre} ${e.apellido}`,
          }))
        );
      } catch {
        setOptions([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleChange = (_, d) => {
    onChange(d.value);
    if (onEmployeeChange) {
      const found = employees.find((e) => e.numero_legajo === d.value) || null;
      onEmployeeChange(found);
    }
  };

  return (
    <Dropdown
      selection
      search
      fluid={fluid}
      clearable
      placeholder={placeholder}
      options={options}
      value={value || ""}
      onChange={handleChange}
      loading={loading}
    />
  );
}
